<template>
    <q-img :src="url" fit="cover" class="col-auto" style="border-radius: 12px" />
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'Image',
    mixins: [uiControlMixin],
    computed: {
        url () {
            return this.params.url;
        },
    },
};
</script>

<style scoped>

</style>
